import React, { useState } from "react";
import _ from "lodash";
import { BONUS_PRICE } from "../../../constants/defaults";

const DrugPageBanner = ({ openSignupModal }) => {
  const handleOnClick = () => {
    openSignupModal();
    _.triggerGTMVirtualPageViewEvent({
      event: "drugPageBannerClick",
      loyaltySignupPath: "Drug_page_banner"
    });
  };
  return (
    <>
      <div
        className="pricingBannerNew themeFocus"
        tabIndex="0"
        onClick={handleOnClick}
        onKeyDown={e => {
          if (e.key === "Enter") handleOnClick();
        }}
      >
        <p className="bannerText">
          Save an <span>extra ${BONUS_PRICE}</span> on any eligible prescription below!{" "}
          <span>Sign up for free</span>
        </p>
      </div>
      <div
        className="pricingBannerNewV2 themeFocus"
        tabIndex="0"
        onClick={handleOnClick}
        onKeyDown={e => {
          if (e.key === "Enter") handleOnClick();
        }}
      >
        <p className="bannerText">
          Members can <span>save even more</span>
          <br className="mobile-only" /> and it's <span>free to join</span>
        </p>
      </div>
    </>
  );
};

export default DrugPageBanner;
